<template>
    <div id="app">
        <!-- <Game501 msg="Welcome to Your Vue.js App"/> -->
        <Milestones />
    </div>
</template>

<script>
    import Game501 from './components/Game501.vue'
    import Milestones from './components/Milestones.vue'

    export default {
        name: 'Home',
        components: {
            Milestones,
            Game501
        }
    }
</script>

<style>
    #app {
        /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
    }
</style>
